import { createContext, useContext } from "react";

import type { UseDockLayoutResult } from "./useDockLayout";

export const DockLayoutContext = createContext<UseDockLayoutResult | null>(null);

export function useDockLayoutContext(): UseDockLayoutResult {
    const context = useContext(DockLayoutContext);
    if (!context) {
        throw new Error("useDockLayoutContext must be used within a DockLayoutProvider");
    }
    return context;
}
